import { createFileRoute, redirect } from '@tanstack/react-router';
import { IdentitiesSection } from '@/components/identities';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/settings_/identities')(
  {
    component: IdentitiesPage,
    beforeLoad: async ({ context }) => {
      // Org owner/admin capability (org-scoped). Not platform/super-admin.
      if (!hasPermission(context.userRole, { identities: ['read'] })) {
        throw redirect({ to: '/' });
      }
    },
  },
);

function IdentitiesPage() {
  return <IdentitiesSection />;
}
